export const COMMENTS_DRAWER = 'comments-drawer';
export const OW_COMMENTS_DRAWER = 'ow-comments-drawer';
export const HEADER_ACCOUNT_BUTTON = 'header-account-button';
export const PROFILE_MENU = 'profile_menu';
